"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function Error(props) {
    return (React.createElement("svg", Object.assign({ width: 60, height: 60, viewBox: "0 0 60 60" }, props),
        React.createElement("title", null, "Error.Icon"),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { fill: "#F01", fillRule: "nonzero" },
                React.createElement("path", { d: "M29.508 55.257c14.124 0 25.574-11.45 25.574-25.573 0-14.124-11.45-25.574-25.574-25.574-14.124 0-25.574 11.45-25.574 25.574 0 14.124 11.45 25.573 25.574 25.573zm0 3.935C13.211 59.192 0 45.98 0 29.684 0 13.387 13.211.175 29.508.175c16.297 0 29.508 13.212 29.508 29.509s-13.21 29.508-29.508 29.508z" }),
                React.createElement("path", { d: "M33.148 29.163l7.255 7.254-3.536 3.536-7.254-7.254-7.254 7.254-3.536-3.536 7.254-7.254-7.254-7.254 3.536-3.536 7.254 7.254 7.254-7.254 3.536 3.536z" })))));
}
exports.default = Error;
//# sourceMappingURL=Error.js.map